import styles from './Example.module.css'

interface Props {
    text: string
    value: string
    onClick: (value: string) => void
    loading: boolean
}

export const Example = ({ text, value, onClick, loading }: Props) => {
    return (
        <div
            className={
                loading ? `skeleton ${styles.skeletonSize}` : styles.example
            }
            onClick={() => onClick(value)}
        >
            <p className={styles.exampleText}>{text}</p>
        </div>
    )
}
